export const SEARCH_MEMBER_RESULT = 'SEARCH_MEMBER_RESULT'
export const COUPONS_INFO = 'COUPONS_INFO'
export const PENDING_APPROVAL_COUPONS = 'PENDING_APPROVAL_COUPONS'
export const OUTSIDE_THE_STORE_APPLICATION_TYPE_OPTIONS = 'OUTSIDE_THE_STORE_APPLICATION_TYPE_OPTIONS'



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/card-operation/store/mutations-types.js